var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNephrology(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "nephrology"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_48",
    d: "M68,3l0,62c0,1.656 -1.344,3 -3,3l-62,0c-1.656,0 -3,-1.344 -3,-3l0,-62c0,-1.656 1.344,-3 3,-3l62,0c1.656,0 3,1.344 3,3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 54.105,
    height: 48.667
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M41.21,26.508c-0.419,-0.393 -0.733,-0.672 -1.029,-0.967c-2.573,-2.356 -3.47,-6.054 -2.263,-9.327c1.002,-3.256 3.843,-5.625 7.226,-6.027c3.597,-0.628 7.282,0.555 9.841,3.16c2.549,2.385 4.348,5.461 5.176,8.852c1.766,6.012 1.089,12.484 -1.882,18c-0.482,0.895 -1.658,2.539 -1.658,2.539c-1.102,1.204 -2.318,2.298 -3.631,3.268c-2.98,1.969 -6.749,2.341 -10.056,0.993c-1.128,-0.442 -2.144,-1.128 -2.976,-2.009c-0.231,-0.238 -0.481,-0.458 -0.918,-0.872l0,12.963c0.048,0.307 0.028,0.621 -0.059,0.919c-0.142,0.267 -0.485,0.589 -0.739,0.588c-0.254,-0.001 -0.566,-0.33 -0.752,-0.587c-0.114,-0.158 -0.048,-0.452 -0.048,-0.685c0,-6.232 -0.017,-12.464 0.01,-18.7c-0.04,-2.944 1.441,-5.71 3.914,-7.309c1.582,-1.1 3.499,-1.615 5.42,-1.456c0.193,0.013 0.386,0.021 0.62,0.033c0.276,-0.609 0.007,-1.218 0.134,-1.883c-0.356,-0.035 -0.612,-0.07 -0.869,-0.083c-0.738,0.033 -1.477,-0.011 -2.206,-0.133c-0.833,-0.206 -1.712,-0.112 -2.483,0.265c-1.874,0.684 -3.545,1.833 -4.853,3.339c-1.538,1.942 -2.341,4.365 -2.267,6.841c-0.032,6.232 -0.011,12.464 -0.012,18.7c0.011,0.311 0.004,0.623 -0.021,0.934c-0.035,0.437 -0.395,0.783 -0.833,0.8c-0.409,-0.014 -0.741,-0.348 -0.753,-0.757c-0.023,-0.31 -0.019,-0.622 -0.019,-0.934c0,-6.115 0.022,-12.231 -0.024,-18.346c-0.012,-1.243 -0.167,-2.481 -0.461,-3.689c-0.524,-2.229 -1.904,-4.164 -3.84,-5.385c-0.967,-0.577 -1.966,-1.102 -2.99,-1.571c-0.703,-0.339 -1.505,-0.418 -2.261,-0.221c-0.979,0.14 -1.967,0.212 -2.956,0.215c-0.161,0.582 -0.209,1.19 -0.143,1.79c0.995,0.082 1.96,0.094 2.9,0.25c3.423,0.596 6.164,3.209 6.923,6.6c0.157,0.721 0.239,1.456 0.245,2.193c0.02,6.115 0.013,12.23 0.014,18.346c0.01,0.233 0.004,0.467 -0.017,0.7c-0.028,0.423 -0.383,0.756 -0.807,0.756c-0.019,-0 -0.038,-0.001 -0.057,-0.002c-0.408,-0.031 -0.724,-0.382 -0.712,-0.791c-0.012,-0.272 -0.008,-0.545 -0.008,-0.818l-0,-12.763c-0.2,0.099 -0.388,0.222 -0.558,0.366c-2.522,3.14 -7.847,4.058 -11.8,2.25c-2.768,-1.305 -5.062,-3.439 -6.562,-6.106c-2.353,-4.028 -3.424,-8.679 -3.068,-13.331c0.14,-4.511 1.715,-8.861 4.494,-12.417c1.727,-2.29 4.172,-3.937 6.943,-4.677c3.842,-0.994 8.347,0.335 10.587,3.641c2.532,3.706 1.942,8.765 -1.376,11.788l-0.863,0.786c3.237,1.191 5.847,3.661 7.213,6.828c1.43,-3.433 3.994,-5.424 7.169,-6.858m18.262,1.967c-0.059,-0.641 -0.127,-1.728 -0.265,-2.806c-0.376,-3.425 -1.681,-6.682 -3.775,-9.418c-2.387,-3.055 -5.422,-4.908 -9.46,-4.5c-3.856,0.222 -6.909,3.455 -6.909,7.318c-0,0.552 0.062,1.103 0.186,1.641c0.793,3.466 4.041,5.851 7.586,5.571c0.665,-0.014 1.275,-0.381 1.6,-0.961c0.475,-0.706 1.024,-1.359 1.637,-1.948c0.2,-0.183 0.446,-0.308 0.711,-0.363c0.348,-0.114 0.731,0.049 0.889,0.38c0.198,0.308 0.128,0.721 -0.16,0.947c-0.227,0.211 -0.5,0.38 -0.718,0.6c-1.022,0.959 -1.603,2.299 -1.603,3.701c0,1.674 0.829,3.244 2.211,4.189c0.295,0.146 0.483,0.448 0.483,0.777c0,0.183 -0.057,0.36 -0.164,0.508c-0.156,0.202 -0.396,0.32 -0.651,0.32c-0.224,-0 -0.439,-0.092 -0.594,-0.254c-0.558,-0.353 -1.046,-0.806 -1.44,-1.336c-0.488,-0.863 -1.435,-1.368 -2.424,-1.294c-0.501,-0.008 -1.002,0.014 -1.5,0.064c-3.818,0.595 -6.495,4.186 -5.977,8.015c0.542,3.769 3.806,6.596 7.614,6.596c0.469,0 0.937,-0.043 1.398,-0.128c3.035,-0.508 5.733,-2.238 7.46,-4.785c2.719,-3.665 3.779,-7.874 3.863,-12.828m-50.909,0.467c0.108,1.16 0.159,2.329 0.333,3.48c0.456,3.818 2.104,7.398 4.707,10.228c2.54,2.655 5.6,4.044 9.358,3.277c3.61,-0.592 6.225,-3.847 6.024,-7.5c-0.073,-3.702 -3.052,-6.747 -6.751,-6.9c-1.19,-0.059 -2.385,-0.041 -3.152,1.247c-0.448,0.585 -0.998,1.085 -1.622,1.477c-0.136,0.122 -0.312,0.189 -0.494,0.189c-0.261,0 -0.503,-0.138 -0.636,-0.363c-0.108,-0.139 -0.167,-0.311 -0.167,-0.487c-0,-0.262 0.129,-0.507 0.345,-0.655c0.149,-0.124 0.32,-0.221 0.471,-0.345c1.218,-0.949 1.931,-2.41 1.931,-3.954c-0,-1.544 -0.713,-3.005 -1.931,-3.954c-0.15,-0.124 -0.365,-0.217 -0.436,-0.376c-0.138,-0.258 -0.199,-0.55 -0.175,-0.841c0.07,-0.297 0.337,-0.508 0.642,-0.508c0.061,-0 0.122,0.008 0.181,0.025c0.306,0.052 0.592,0.191 0.822,0.4c0.608,0.541 1.139,1.162 1.578,1.847c0.341,0.662 1.031,1.074 1.775,1.061c3.338,0.229 6.409,-1.928 7.326,-5.146c0.973,-3.282 -0.493,-6.828 -3.5,-8.464c-2.494,-1.303 -5.461,-1.356 -8,-0.144c-2.235,1.048 -4.106,2.74 -5.374,4.858c-2.144,3.468 -3.272,7.47 -3.255,11.548",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M53.701,29.867c-0.547,-0.1 -0.9,-0.321 -1,-0.8c-0.109,-0.514 0.209,-0.8 0.674,-0.911c0.733,-0.087 1.413,-0.425 1.924,-0.957c0.116,-0.14 0.59,-0.1 0.829,0.008c0.249,0.099 0.412,0.341 0.412,0.609c0,0.094 -0.02,0.187 -0.059,0.273c-0.13,0.361 -0.364,0.677 -0.671,0.907c-0.686,0.331 -1.392,0.622 -2.112,0.87",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M45.618,23.914c-1.031,0.037 -1.988,-0.55 -2.421,-1.486c-0.235,-0.381 -0.116,-0.887 0.264,-1.123c0.13,-0.098 0.288,-0.151 0.451,-0.151c0.277,0 0.532,0.154 0.662,0.399c0.27,0.477 0.782,0.767 1.33,0.753c0.675,0.023 0.923,0.312 0.9,0.811c-0.023,0.499 -0.334,0.749 -0.95,0.8c-0.077,0.006 -0.155,0 -0.233,0",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M50.507,42.38c-0.468,0.019 -0.859,-0.084 -0.958,-0.624c-0.091,-0.494 0.133,-0.83 0.728,-0.971c0.542,-0.075 1.026,-0.381 1.327,-0.838c0.134,-0.235 0.384,-0.381 0.655,-0.381c0.169,0 0.334,0.058 0.467,0.163c0.443,0.273 0.415,0.716 0.244,1.139c-0.499,0.899 -1.435,1.474 -2.463,1.511",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M48.522,15.661c-0.143,0.6 -0.215,1.016 -0.348,1.416c-0.094,0.348 -0.412,0.591 -0.772,0.591c-0.082,-0 -0.162,-0.013 -0.24,-0.037c-0.345,-0.052 -0.603,-0.352 -0.603,-0.701c0,-0.097 0.02,-0.194 0.059,-0.283c0.22,-0.543 0.183,-1.157 -0.1,-1.669c-0.06,-0.104 -0.092,-0.222 -0.092,-0.342c0,-0.281 0.173,-0.535 0.435,-0.638c0.121,-0.085 0.265,-0.13 0.413,-0.13c0.253,-0 0.488,0.133 0.618,0.35c0.237,0.468 0.446,0.95 0.626,1.443",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M53.952,18.045c-0.035,0.178 -0.068,0.408 -0.128,0.63c-0.102,0.336 -0.414,0.568 -0.766,0.568c-0.351,-0 -0.663,-0.232 -0.765,-0.568c-0.054,-0.65 -0.239,-1.282 -0.544,-1.859c-0.111,-0.192 0.068,-0.7 0.275,-0.893c0.319,-0.254 0.787,-0.213 1.056,0.093c0.532,0.546 0.843,1.27 0.871,2.032",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M46.02,39.86c0.6,0 1.064,0.428 0.909,0.887c-0.149,0.51 -0.133,1.055 0.046,1.556c0.076,0.355 -0.125,0.714 -0.466,0.837c-0.319,0.166 -0.716,0.075 -0.931,-0.213c-0.611,-0.821 -0.633,-1.946 -0.055,-2.79c0.151,-0.119 0.319,-0.212 0.5,-0.277",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M49.51,38.249c-0.425,-0.189 -0.838,-0.406 -1.234,-0.649c-0.186,-0.113 -0.3,-0.315 -0.3,-0.533c-0,-0.141 0.048,-0.279 0.136,-0.389c0.222,-0.247 0.524,-0.408 0.853,-0.453c0.447,0.015 0.892,0.058 1.334,0.129c0.399,-0.019 0.758,0.254 0.846,0.644c0.106,0.35 -0.078,0.727 -0.418,0.861c-0.396,0.158 -0.803,0.288 -1.217,0.389",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M49.406,19.229c0.537,-0.005 0.836,0.244 0.854,0.713c0.021,0.578 -0.734,1.146 -1.5,1.129c-0.004,0 -0.008,0 -0.011,0c-0.423,0 -0.771,-0.348 -0.771,-0.771c-0,-0.016 0,-0.031 0.001,-0.047c-0.011,-0.561 0.624,-1.016 1.43,-1.025",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M45.211,36.089c-0.094,-0.02 -0.383,0 -0.525,-0.131c-0.226,-0.188 -0.369,-0.456 -0.4,-0.748c0.018,-0.24 0.288,-0.5 0.507,-0.672c0.125,-0.1 0.371,-0.062 0.562,-0.062c0.676,-0 1.077,0.277 1.107,0.75c0.033,0.523 -0.42,0.872 -1.257,0.862",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M56.533,33.704c0.053,0.56 -0.323,1.078 -0.873,1.2c-0.028,0.003 -0.056,0.004 -0.085,0.004c-0.439,0 -0.8,-0.361 -0.8,-0.8c0,-0.017 0.001,-0.035 0.002,-0.052c-0.057,-0.558 0.317,-1.077 0.864,-1.2c0.021,-0.002 0.042,-0.002 0.062,-0.002c0.456,-0 0.83,0.374 0.83,0.83c0,0.009 0,0.018 -0,0.027",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M43.505,38.811c-0.04,0.597 -0.484,1.093 -1.072,1.2c-0.444,-0.026 -0.791,-0.407 -0.775,-0.851c0.046,-0.597 0.497,-1.088 1.088,-1.184c0.006,-0 0.013,-0 0.019,-0c0.409,-0 0.745,0.336 0.745,0.745c0,0.029 -0.002,0.058 -0.005,0.087",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M55.853,24.008c-0.018,0.442 -0.378,0.799 -0.82,0.813c-0.599,-0.012 -1.104,-0.467 -1.178,-1.062c0.026,-0.412 0.373,-0.738 0.786,-0.738c0.029,0 0.058,0.002 0.086,0.005c0.559,0.018 1.032,0.432 1.125,0.983",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M43.915,17.596c-0.012,0.436 -0.356,0.795 -0.791,0.827c-0.556,0.019 -1.056,-0.351 -1.2,-0.888c-0.002,-0.025 -0.004,-0.051 -0.004,-0.076c0,-0.43 0.354,-0.784 0.784,-0.784c0.024,-0 0.047,0.001 0.07,0.003c0.554,-0.024 1.045,0.372 1.138,0.919",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M22.387,23.92c-0.186,-0.004 -0.372,-0.03 -0.552,-0.077c-0.351,-0.098 -0.58,-0.443 -0.532,-0.805c0.022,-0.4 0.239,-0.73 0.624,-0.71c0.706,0.052 1.384,-0.299 1.75,-0.905c0.131,-0.18 0.651,-0.208 0.93,-0.117c0.436,0.143 0.467,0.577 0.362,0.985c-0.406,1.051 -1.461,1.716 -2.584,1.629",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M14.308,29.74c-0.982,-0.035 -1.901,-0.495 -2.518,-1.26c-0.139,-0.155 -0.215,-0.356 -0.215,-0.564c-0,-0.264 0.123,-0.514 0.333,-0.674c0.309,-0.252 0.7,-0.324 0.936,-0.006c0.467,0.524 1.119,0.847 1.819,0.9c0.479,0.1 0.788,0.328 0.747,0.857c-0.037,0.481 -0.4,0.746 -1.1,0.746",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M17.54,42.384c-0.993,-0.033 -1.895,-0.597 -2.359,-1.475c-0.263,-0.358 -0.195,-0.867 0.153,-1.144c0.14,-0.115 0.315,-0.179 0.496,-0.179c0.289,0 0.554,0.16 0.689,0.415c0.325,0.434 0.814,0.718 1.352,0.786c0.444,0.033 0.786,0.417 0.769,0.862c0.006,0.42 -0.452,0.728 -1.1,0.733",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M20.608,13.911c0.825,-0.028 1.244,0.5 0.965,1.084c-0.247,0.482 -0.284,1.046 -0.1,1.556c0.05,0.103 0.076,0.216 0.076,0.33c-0,0.328 -0.212,0.619 -0.523,0.721c-0.097,0.039 -0.2,0.059 -0.304,0.059c-0.375,-0 -0.704,-0.256 -0.796,-0.619c-0.397,-0.819 -0.365,-1.783 0.087,-2.573c0.169,-0.217 0.372,-0.405 0.6,-0.558",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M14.094,17.894c0.231,-0.594 0.506,-1.169 0.823,-1.722c0.152,-0.257 0.43,-0.415 0.728,-0.415c0.175,0 0.345,0.054 0.488,0.155c0.371,0.267 0.4,0.681 0.118,1.227c-0.167,0.293 -0.288,0.61 -0.356,0.94c-0.134,0.894 -0.369,1.212 -0.947,1.142c-0.506,-0.061 -0.725,-0.45 -0.853,-1.327",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M23.161,41.511c-0.185,0.489 -0.409,0.963 -0.67,1.416c-0.2,0.308 -0.616,0.401 -0.927,0.206c-0.342,-0.128 -0.533,-0.501 -0.436,-0.853c0.178,-0.503 0.194,-1.049 0.045,-1.561c-0.054,-0.216 0.259,-0.676 0.5,-0.771c0.32,-0.078 0.658,0.01 0.9,0.233c0.253,0.416 0.451,0.863 0.588,1.33",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M18.485,38.279c-0.435,-0.13 -0.853,-0.313 -1.243,-0.545c-0.175,-0.143 -0.277,-0.357 -0.277,-0.583c-0,-0.384 0.295,-0.709 0.677,-0.747c0.531,0.035 1.064,-0.025 1.573,-0.178c0.171,-0.074 0.652,0.183 0.74,0.393c0.119,0.308 0.082,0.655 -0.1,0.93c-0.426,0.296 -0.886,0.541 -1.369,0.73",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M20.128,20.212c0.004,0.03 0.005,0.061 0.005,0.091c0,0.412 -0.332,0.754 -0.744,0.765c-0.667,0.05 -1.557,-0.583 -1.551,-1.1c0.015,-0.443 0.379,-0.8 0.822,-0.807c0.649,-0.014 1.439,0.554 1.468,1.054",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M22.762,36.1c-0.145,0.003 -0.29,-0.012 -0.432,-0.045c-0.181,-0.053 -0.347,-0.146 -0.487,-0.272c-0.275,-0.243 -0.302,-0.668 -0.06,-0.944c0.386,-0.397 0.979,-0.517 1.488,-0.3c0.279,0.171 0.476,0.449 0.547,0.768c0.08,0.44 -0.233,0.705 -0.681,0.764c-0.115,0.015 -0.231,0.017 -0.376,0.028",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    d: "M13.318,34.026c0.001,0.019 0.002,0.038 0.002,0.056c-0,0.45 -0.37,0.82 -0.82,0.82c-0.015,0 -0.031,-0 -0.046,-0.001c-0.551,-0.11 -0.936,-0.624 -0.887,-1.184c-0,-0.008 -0,-0.015 -0,-0.023c-0,-0.465 0.383,-0.849 0.849,-0.849c0.01,0 0.02,0.001 0.03,0.001c0.554,0.099 0.94,0.62 0.872,1.179",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M26.436,39.226c-0.011,0.431 -0.368,0.78 -0.8,0.78c-0.012,-0 -0.025,-0 -0.037,-0.001c-0.58,-0.142 -0.993,-0.662 -1,-1.259c-0,-0.01 -0.001,-0.019 -0.001,-0.029c0,-0.404 0.333,-0.737 0.737,-0.737c0.032,-0 0.064,0.002 0.095,0.006c0.589,0.115 1.015,0.641 1.006,1.241",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    d: "M14.249,23.821c-0.134,0.579 -0.648,0.996 -1.242,1.007c-0.439,-0.05 -0.769,-0.436 -0.75,-0.877c0.147,-0.536 0.63,-0.916 1.186,-0.933c0.008,-0 0.015,-0 0.023,-0c0.43,-0 0.783,0.353 0.783,0.783c0,0.005 0,0.011 -0,0.017",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M26.172,17.407c-0.043,0.566 -0.543,0.998 -1.11,0.958c-0.029,0.003 -0.057,0.005 -0.086,0.005c-0.413,-0 -0.762,-0.321 -0.797,-0.733c0.081,-0.556 0.566,-0.97 1.128,-0.963c0.036,-0.005 0.073,-0.008 0.109,-0.008c0.409,0 0.748,0.332 0.756,0.741",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNephrology);
export default __webpack_public_path__ + "static/media/nephrology.c23b3206892fc45cb47274ab728e9cfc.svg";
export { ForwardRef as ReactComponent };